import React, { useEffect } from 'react';
import { CONTACT_INFO } from '../data/mock';

export const CalendlyEmbed = ({ minimal = false }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div
      className="calendly-inline-widget"
      data-url={`${CONTACT_INFO.calendlyUrl}?hide_gdpr_banner=1&background_color=ffffff&text_color=003720&primary_color=8FEC78`}
      style={{ minWidth: '320px', height: minimal ? '500px' : '660px', width: '100%' }}
    />
  );
};
